import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed",
  style: {"background-image":"url('media/illustrations/landing.svg')"}
}
const _hoisted_2 = { class: "d-flex flex-column flex-column-fluid text-center p-10 py-lg-20" }
const _hoisted_3 = { class: "pt-lg-10" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", { class: "fw-bolder fs-4x text-gray-700 mb-8" }, "Not Found", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-3 text-gray-400 mb-15" }, " The page you looked not found! ", -1)
const _hoisted_6 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode("a", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.gotoDashboard && _ctx.gotoDashboard(...args))),
            class: "btn btn-lg btn-primary fw-bolder"
          }, "Go to dashboard")
        ])
      ])
    ])
  ]))
}